import React from 'react';
import SearchForm from './form';
import Installations from './installations';

export default function(){
  return <React.Fragment>
    <SearchForm />
    <Installations />
  </React.Fragment>;
}